import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { UserContextConsumer } from '../../../../contexts/UserContext';
import Button, { ButtonSize } from '../../buttons/Button';
import css from './GlobalNav.module.scss';
import GlobalNavModalMenu from './GlobalNavModalMenu';
import UserMenu from './UserMenu';

interface Props extends React.HTMLProps<{}> {}
interface State extends React.HTMLProps<{}> {
  isModalOpen?: boolean;
  userMenu: {
    isActive: boolean;
    toggle: (flag: boolean) => void;
  };
}

class GlobalNav extends React.Component<Props & InjectedIntlProps, State> {
  constructor(props: Props & InjectedIntlProps) {
    super(props);

    this.toggleUserMenu = this.toggleUserMenu.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);

    this.state = {
      isModalOpen: false,
      userMenu: {
        isActive: false,
        toggle: this.toggleUserMenu,
      },
    };
  }

  private openModal() {
    this.setState({
      isModalOpen: true,
    });
  }

  private closeModal() {
    this.setState({
      isModalOpen: false,
    });
  }

  private toggleUserMenu(flag: boolean) {
    this.setState({
      ...this.state,
      userMenu: {
        ...this.state.userMenu,
        isActive: flag,
      },
    });
  }

  public render() {
    const { intl, className } = this.props;
    const intlPref = 'components.common.layouts.globalHeader.';

    return (
      <UserContextConsumer>
        {context => (
          <nav className={classNames(css.GlobalNav, className)}>
            <div className={css.GlobalNav__Inner}>
              <a href="/" className={css.GlobalNav__Logo}>
                <svg className={css.GlobalNav__LogoImage}>
                  <use xlinkHref="#text-logo" />
                </svg>
              </a>

              <div className={css.GlobalNav__Buttons}>
                {!context.auth.isLoggedIn && (
                  <a
                    href="https://stores.jp/reserve"
                    className={css.GlobalNav__TextLink}
                  >
                    {intl.formatMessage({ id: intlPref + 'links.business' })}
                  </a>
                )}
                {context.auth.isLoggedIn && (
                  <a href="/dashboard" className={css.GlobalNav__TextLink}>
                    {intl.formatMessage({ id: intlPref + 'links.dashboard' })}
                  </a>
                )}
                {context.auth.isLoggedIn && context.auth.user && (
                  <UserMenu
                    user={context.auth.user}
                    {...this.state.userMenu}
                    logout={async () => {
                      await context.auth.logout();
                      location.href = `/login?return_to=${location.pathname}`;
                    }}
                  />
                )}
                {!context.auth.isLoggedIn && (
                  <>
                    <Button
                      isGhost={true}
                      buttonSize={ButtonSize.Medium}
                      className={css.GlobalNav__Button}
                      tag="a"
                      onClick={() =>
                        (location.href = `/login?return_to=${location.pathname}`)
                      }
                    >
                      {intl.formatMessage({ id: intlPref + 'buttons.signin' })}
                    </Button>
                    <svg
                      className={css.GlobalNav__MenuButton}
                      onClick={this.openModal}
                    >
                      <use xlinkHref="#globalnav-menu" />
                    </svg>
                  </>
                )}
              </div>
            </div>
            {this.state.isModalOpen && (
              <GlobalNavModalMenu handleClose={this.closeModal} />
            )}
          </nav>
        )}
      </UserContextConsumer>
    );
  }
}

export default injectIntl(GlobalNav);
